<template>
    <div class="editDialog">
        <el-dialog
            title="出库"
            :visible.sync="dialogShow"
            :before-close="handleClose"
            width="700px"
            :close-on-click-modal="false"
        >
            <div class="content">
                <el-form
                    :inline="true"
                    :model="formEdit"
                    label-width="80px"
                    :rules="rules"
                    :ref="refName"
                >
                    <div class="el-form-area">
                        <el-form-item label="客户" prop="companyId">
                            <el-select v-model="formEdit.companyId" placeholder="请选择客户">
                                <el-option
                                    v-for="(item, index) in companyList"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="生效日期" prop="date">
                            <el-date-picker
                                v-model="formEdit.date"
                                type="daterange"
                                range-separator="-"
                                value-format="yyyy-MM-dd"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                            ></el-date-picker>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSubmit">确定</el-button>
                <el-button @click="handleClose">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import editDialogMixin from '@/mixins/editDialogMixin';
export default {
    props: {
        allotDialogData: {
            type: Object
        },
        companyList: {
            type: Array,
            default() {
                return []
            }
        }
    },
    mixins: [editDialogMixin],
    data() {
        return {
            formReset: {
                companyId: ''
            },
            rules: {
                companyId: [
                    {
                        required: true,
                        message: '项目不能为空'
                    }
                ],
                date: [
                    {
                        required: true,
                        message: '请选择服务日期',
                        type: 'array'
                    }
                ]
            },
            plantCategoryList: [], // 绿植类目列表 
            plantList: [] // 绿植实体列表
        };
    },
    methods: {
        handleSubmit() {
            this.$refs[this.refName].validate(valid => {
                if (valid) {
                    this.$confirm('确认出库吗？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.$http
                            .put(
                                '/device/allot/v1',
                                {
                                    ...this.formEdit,
                                    deviceId: this.allotDialogData.deviceId,
                                    companyId: this.formEdit.companyId,
                                    start: this.formEdit.date[0],
                                    end: this.formEdit.date[1]
                                },
                                '提交中……',
                                '出库成功'
                            )
                            .then(res => {
                                this.$emit('updateData');
                                this.handleClose();
                            });
                    });
                }
            });
        }
    }
};
</script>